module.exports = __webpack_public_path__ + "static/media/ams-success.de0cb672.gif";